var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"action-button",class:{ 'action-button--is-highlighted': _vm.isHighlighted, 'action-button--deactivated': _vm.deactivated },attrs:{"id":_vm.id},on:{"click":_vm.emitClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }